export function restoInfoPath(resto = {}) {
  const params = new URLSearchParams();
  const fields = [
    "name",
    "rating",
    "price",
    "cuisine",
    "address",
    "hours",
    "website",
    "phone",
    "instagram",
    "booking",
    "MapApple",
    "MapAndroid",
    "picture",
    "menu",
  ];
  fields.forEach((k) => {
    if (resto[k] != null && resto[k] !== "") params.set(k, String(resto[k]));
  });
  const id =
    resto.id ||
    resto.restaurantId ||
    (typeof resto._id === "string" ? resto._id : resto._id?.toString?.() || "");
  if (id) params.set("id", String(id));
  return `/restoInfo?${params.toString()}`;
}

export function primaryCuisine(cuisine) {
  if (!cuisine) return "";
  const raw = String(cuisine)
    .split(",")[0]
    .trim()
    .replace(/_/g, " ");
  return raw.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function areaFromAddress(address) {
  if (!address) return "";
  const parts = String(address)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length >= 2) return parts[1];
  return parts[0] || "";
}

export function formatRating(rating) {
  if (rating == null || rating === "") return "";
  const n = Number(rating);
  if (Number.isNaN(n)) return String(rating);
  return n % 1 === 0 ? n.toFixed(1) : String(rating);
}
